import { useQuery } from '@tanstack/react-query';
import { getPrompts } from 'services/api/WorkflowServiceAPI';
import { queryKeys } from '../queryKeys';

export const useGetPrompts = () => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.prompts,
        queryFn: () => getPrompts(),
    });

    return { prompts: data?.prompts, isLoadingPrompts: isLoading, ...rest };
};
